import { render } from "./ProductThumbnail.vue?vue&type=template&id=b42286ae&scoped=true"
import script from "./ProductThumbnail.vue?vue&type=script&lang=js"
export * from "./ProductThumbnail.vue?vue&type=script&lang=js"

import "./ProductThumbnail.vue?vue&type=style&index=0&id=b42286ae&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42286ae"]])

export default __exports__